import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "backgroundColorToken", "backgroundColorTokenArgs", "cornerRadiusToken", "children", "disabled", "id", "onPress", "paddingToken", "testID", "UNSAFE_props", "UNSAFE_style"];
import React from 'react';
import View from '@bubble-ui/primitive-view';
import Touchable from '@bubble-ui/primitive-touchable';
import Frame from '@bubble-ui/molecule-frame';
import { useInteractiveStateCase } from '@bubble-ui/hook-use-interactive-state';
import { platformSelect } from '@bubble-ui/util-platform';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
/**
 * Touchable frames can be used as navigational or actionable items, where the entire frame is interactive.
 * @talebook https://bubble-ui.klarna.net/#components/touchable-frame
 */
var TouchableFrame = _ref => {
  var {
      accessibilityLabel,
      backgroundColorToken = 'touchable-frame/background-color',
      backgroundColorTokenArgs,
      cornerRadiusToken = 'touchable-frame/corner-radius',
      children,
      disabled,
      id,
      onPress,
      paddingToken = 'touchable-frame/padding',
      testID,
      UNSAFE_props,
      UNSAFE_style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var [interactiveState, eventHandlers] = useInteractiveStateCase(props);
  var designContext = useDesignContext(defaultDesignTokens);
  var {
    rootStyle,
    keyboardFocusedStyle,
    wrapperStyle
  } = getDefaultStyleSheet({
    designContext,
    disabled
  });
  return /*#__PURE__*/React.createElement(Touchable, _extends({}, platformSelect({
    native: {
      testID
    },
    default: {
      id
    }
  }), UNSAFE_props, {
    style: rootStyle,
    ariaLabel: accessibilityLabel
  }, disabled ? {} : {
    onPress
  }, {
    accessibilityState: {
      disabled
    },
    disabled: disabled,
    type: "button"
  }, eventHandlers), /*#__PURE__*/React.createElement(View, {
    style: wrapperStyle
  }, interactiveState === 'keyboardFocused' && /*#__PURE__*/React.createElement(View, {
    style: keyboardFocusedStyle
  }), /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(Frame, {
    backgroundColorToken: backgroundColorToken,
    backgroundColorTokenArgs: backgroundColorTokenArgs || {
      interactiveState: !disabled ? interactiveState : 'default'
    },
    cornerRadiusToken: cornerRadiusToken,
    paddingToken: paddingToken,
    UNSAFE_style: UNSAFE_style
  }, children))));
};
TouchableFrame.displayName = 'TouchableFrame';
export default TouchableFrame;
//# sourceMappingURL=index.js.map